import React from "react";
import EditableText from "./EditableText";
import { translations } from "../i18n";

const get = (obj, path) => path.split(".").reduce((o, p) => (o == null ? undefined : o[p]), obj);

// Editable wrapper for any i18n string: k="nav.services" → settings keys txt_nav_services_en/fr
export default function EditableI18n({ k, label, as, className, children, ...rest }) {
  const key = "txt_" + k.replace(/[^a-zA-Z0-9]+/g, "_").toLowerCase();
  return (
    <EditableText
      kEn={`${key}_en`}
      kFr={`${key}_fr`}
      label={label || k}
      fallback={{ en: String(get(translations.en, k) ?? ""), fr: String(get(translations.fr, k) ?? "") }}
      as={as}
      className={className}
      {...rest}
    >
      {children}
    </EditableText>
  );
}
